// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import uuidv4 from 'uuid/v4'

const EventTracker = ( accountData, extraData = {} ) => {
	if ( ! siteData.aws_analytics_url ) {
		return
	}

	let analytics_uid

	if ( accountData && accountData.analytics_uid ) {
		analytics_uid = accountData.analytics_uid
	} else if ( Cookies.get( 'analytics_uid' ) ) {
		analytics_uid = Cookies.get( 'analytics_uid' )
	} else {
		analytics_uid = uuidv4()
		Cookies.set( 'analytics_uid', analytics_uid )
	}

	const data = {
		...extraData,
		url: window.location.href,
		referrer: document.referrer,
		anonymous_id: analytics_uid
	}

	axios( {
		url: siteData.aws_analytics_url,
		method: 'post',
		responseType: 'json',
		data: JSON.stringify( data )
	})
	.then( function( response ) {

	})
	.catch( function( error ) {

	})
}

export default EventTracker
